export const CLASS_NAMES = {
  wrapper: {
    base: 'grid grid-cols-3 items-center border border-solid rounded-lg p-4 cursor-pointer text-left shadow-card',
    '@selected': {
      false:
        'bg-neutral-000 border-neutral-300 hover:bg-purple-50 hover:border-purple-100',
      true: 'bg-purple-50 border-purple-300',
    },
  },
  label: {
    base: 'text-14-22-em border-r',
    '@selected': {
      false: 'border-neutral-200 text-neutral-600',
      true: 'border-purple-300 text-purple-400',
    },
  },
  extraItems:
    'flex-grow flex flex-row justify-around items-center px-4 w-full col-span-2',
  extraItem: 'flex flex-col',
  extraItemLabel: 'text-neutral-600 text-10-14-em uppercase',
  extraItemValue: {
    base: 'text-13-14',
    '@preApproved': {
      true: 'text-lavender-200',
      false: 'text-neutral-600',
    },
  },
};
